import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import utils from './utils'
import EventBus from './utils/EventBus'
import Vant from 'vant';
import { Notify, Dialog, Toast, ImagePreview } from 'vant';
import api from '../src/server/api';
import md5 from 'js-md5';
import 'vant/lib/index.css';
import './assets/style/reset.less';
import './assets/style/border.less';
import './assets/style/common.less';
import './assets/style/vent.less';

Vue.config.productionTip = false
Vue.use(Vant);
Vue.prototype.$vant = Vant
Vue.prototype.$EventBus = EventBus
Vue.prototype.$Notify = Notify
Vue.prototype.$Dialog = Dialog
Vue.prototype.$Toast = Toast
Vue.prototype.$api = api
Vue.prototype.$utils = utils
Vue.prototype.$md5 = md5;
Vue.prototype.$ImagePreview = ImagePreview;

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js